'use client'

import { useScreenSize } from 'plp/hooks/useScreenSize'
import type { QuickFiltersProps } from 'plp/types/QuickFilters'

import { Options } from './Options/Options'

import styles from './Squared.module.scss'

export function Squared({ data, catalogId, collection }: QuickFiltersProps) {
	const { showAsMediumOrSmall } = useScreenSize()

	return (
		<div
			className={!showAsMediumOrSmall ? styles.container : ''}
			data-testid='plp.quickfilters.squared'
		>
			<Options
				data={data.navigations}
				catalogId={catalogId}
				showAsMediumOrSmall={showAsMediumOrSmall}
				collection={collection}
			/>
		</div>
	)
}
